import CommonCard from '../../components/TopComp/CommonCard.vue'
export default{
    components:{
        CommonCard
    },
    props:['reportdata']
}